import { Link as RouterLink } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { Card, Link, Container, Typography, Box } from "@mui/material";
import useResponsive from "../hooks/useResponsive";
import { Page } from "../components/Page";
import SimpleRegisterForm from "../sections/auth/register/SimpleRegisterForm";

const RootStyle = styled("div")(({ theme }) => ({
  minHeight: "100vh",
  width: "100vw",
  background: "white",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
}));

const MainFlex = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "stretch",
  justifyContent: "center",
  width: "100%",
  maxWidth: 1000,
  background: "rgba(255,255,255,0.85)",
  boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.18)",
  overflow: "hidden",
  margin: "0 24px", //
  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    maxWidth: "100%",
    margin: "0 12px",
  },
}));

const PhotoSection = styled("div")(({ theme }) => ({
  flex: 1,
  minWidth: 320,
  background: "#1976d2",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  [theme.breakpoints.down("md")]: {
    display: "none",
    minHeight: 0,
    maxHeight: 0,
    width: 0,
    padding: 0,
  },
}));

const StyledImg = styled("img")(({ theme }) => ({
  width: "100%",
  height: "100%",
  objectFit: "cover",
  minHeight: 400,
  [theme.breakpoints.down("md")]: {
    minHeight: 140,
    maxHeight: 180,
    // borderRadius removed
  },
}));

const ContentSection = styled("div")(({ theme }) => ({
  flex: 0.9,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  padding: theme.spacing(4, 2),
  background: "#fff",
  // borderRadius removed
  [theme.breakpoints.down("md")]: {
    // borderRadius removed
    padding: theme.spacing(3, 1),
  },
}));

export default function Register() {
  const smUp = useResponsive("up", "sm", "xs", "lg");

  return (
    <Page title="Register">
      <RootStyle>
        <MainFlex>
          <PhotoSection>
            <StyledImg
              src="/static/images/hotel.jpg"
              alt="Hotel"
            />
          </PhotoSection>
          <ContentSection>
            <Box
              component="img"
              src="/static/images/newlogo1.png"
              sx={{
                width: "180px",
                height: "auto",
                display: "block",
                margin: "4px auto -4px",
                alignItems: "center",
                }}
            />
            <Typography
              variant="h4"
              gutterBottom
              sx={{
                color: "#333333",
                fontWeight: 700,
                fontSize: { xs: 22, sm: 28 },
                textAlign: "center",
                mb: 4,
              }}
            >
              Welcome to PMS
            </Typography>
            {/* <Typography
              variant="h5"
              gutterBottom
              sx={{
                color: "blue",
                fontWeight: 700,
                fontSize: { xs: 16, sm: 20 },
                textAlign: "center",
                mb: 3,
              }}
            >
              Create your account
            </Typography> */}
            <SimpleRegisterForm />

            {smUp && (
              <Box sx={{ display: "flex", justifyContent: "center", mt: 1 }}>
                <Typography
                  variant="body2"
                  sx={{
                    color: "text.secondary",
                    fontSize: 16,
                    px: 3,
                    py: 1.5,
                    // borderRadius removed
                  }}
                >
                  Already have an account?{" "}
                  <Link
                    variant="subtitle2"
                    component={RouterLink}
                    to="/login"
                    sx={{
                      color: "#1976d2",
                      fontWeight: 700,
                      fontSize: 16,
                      textDecoration: "none",
                      transition: "color 0.2s",
                      "&:hover": {
                        color: "#1565c0",
                        textDecoration: "underline",
                      },
                    }}
                  >
                    Login
                  </Link>
                </Typography>
              </Box>
            )}

            <Typography
              variant="body2"
              align="center"
              sx={{
                color: "text.secondary",
                mt: 1,
                fontSize: 13,
              }}
            >
              By registering, I agree to Minimal&nbsp;
              <Link
                color="text.primary"
                target="_blank"
                href="https://ratebotai.com/terms-and-condition"
              >
                Terms of Service
              </Link>
              {" "}and{" "}
              <Link
                color="text.primary"
                target="_blank"
                href="https://ratebotai.com/privacy-policy"
              >
                Privacy Policy
              </Link>
              .
            </Typography>

            {!smUp && (
              <Typography variant="body2" sx={{ mt: 3, textAlign: "center" }}>
                Already have an account?{" "}
                <Link
                  variant="subtitle2"
                  to="/login"
                  component={RouterLink}
                  sx={{
                    color: "#1976d2",
                    fontWeight: 700,
                    textDecoration: "underline",
                    transition: "color 0.2s",
                    "&:hover": {
                      color: "#1565c0",
                      textDecoration: "none",
                    },
                  }}
                >
                  Login
                </Link>
              </Typography>
            )}
          </ContentSection>
        </MainFlex>
      </RootStyle>
    </Page>
  );
}
